import {createStore, applyMiddleware, compose} from "redux";
import createRootReducer from "../reducer";
import {routerMiddleware} from "connected-react-router";
import api from "../../../middlewares/api";
import thunk from "redux-thunk";
import history from "../../common/Router/history";

const IS_BROWSER = typeof window === `object`;
const IS_DEV = IS_BROWSER ? window.location.hostname === `lvh.me` : false;

const composeEnhancers =
  IS_BROWSER && IS_DEV && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

const middlewares = [
  thunk,
  api,
  IS_BROWSER
    ? routerMiddleware(history)
    : () => (next) => (action) => {
        next(action);
      }
];

const enhancer = composeEnhancers(applyMiddleware.apply(this, middlewares));

const createStoreForSSR = (initialStore) =>
  createStore(createRootReducer(history), initialStore, enhancer);

export default createStoreForSSR;
